import BaseApi from 'common/apiRequest/apis/BaseApi';
import { VERIFY_CODE_SCENE } from 'common/constants/Constants';
import { Request } from '../apiConcentrator';
import APINames from '../APINames';

class AuthnApi extends BaseApi {
  public requestInstance = new Request(APINames.AUTHN);

  // 手机验证码验证，非登录
  verifyCode(body: {
    verificationSessionId: string;
    verificationCode: string;
    event?: VERIFY_CODE_SCENE;
  }) {
    return this.requestInstance.post(['credentials', 'sms:verify'], body);
  }

  // 设置邮件密码，邀请页用
  setEmailPassword(data: { password: string; event?: string; app?: string; email?: string }) {
    return this.requestInstance.post(['credentials', 'email_password', ':set'], data);
  }

  // 无企业用户-创建企业
  setupCompany(params: Record<string, any>) {
    return this.requestInstance.post(['accounts'], params);
  }

  logout() {
    return this.requestInstance.post(':logout');
  }

  // 获取邀请信息
  getInvitationInfo(accountId: string, handshakeId: string) {
    return this.requestInstance.get(['accounts', accountId, 'handshakes', handshakeId]);
  }

  // 接受邀请
  acceptInvitation(handshakes: { handshakeId: string; mobile: string }[], app?: string) {
    return this.requestInstance.post(['handshakes', ':accept'], {
      handshakes,
      app,
    });
  }

  // 接受邮箱邀请
  acceptEmailInvitation(handshakeId: string, email: string) {
    return this.requestInstance.post(['handshake', handshakeId, ':accept'], { email });
  }

  // 拒绝邀请
  rejectInvitation(handshakeIds: string[], app?: string) {
    return this.requestInstance.post(['handshakes', ':reject'], { handshakeIds, app });
  }

  // 新拒绝邀请
  declineInvitation(handshakeIds: string[], app?: string) {
    return this.requestInstance.post(['handshakes', ':decline'], { handshakeIds, app });
  }
}
export default new AuthnApi();
